import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import React, { useEffect, useMemo } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import {
    Col,
    Row,
    Form,
    Card,
    ButtonGroup,
    FormText,
    FormGroup,
    Label,
    Input,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import "../../styles.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getFileUploadLogs, getUserLogs } from '../../store/logs/actions';

const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    
    // Define options for date and time formatting
    const options = {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true // Use 24-hour format
    };
    
    const formatter = new Intl.DateTimeFormat('en-US', options);
    
    const formattedDateTime = formatter.format(date);
    
    return formattedDateTime;
};

export const FileUploadLogs = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    let dispatch = useDispatch();

    const columns = useMemo(
        () => [
            {
                name: "File Name",
                selector: (row) => row.file_name ? row.file_name : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "File Extension",
                selector: (row) => row.file_extension ? row.file_extension : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "Event Name",
                selector: (row) => row.show_name ? row.show_name : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "Show Name",
                selector: (row) => row.event_name ? row.event_name : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "CKC Number",
                selector: (row) => row.ckc_number ? row.ckc_number : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "Type",
                selector: (row) => row.type ? row.type : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "Upload Time",
                selector: (row) => row.uploaded_time ? formatDate(row.uploaded_time) : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "Uploaded By",
                selector: (row) => row.role=='admin' ? 'ckc-admin (admin)' : row.secretary_name ? row.secretary_name +` (${row.role})` : (row.staff_name ? row.staff_name+` (${row.role})` : '-'),
                sortable: true,
                wrap: true,
            },
            {
                name: "Error Message",
                selector: (row) => row.error_message ? row.error_message : '-',
                sortable: true,
                wrap: true,
            },
            {
                name: "Success Message",
                selector: (row) => row.success_message ? row.success_message : '-',
                sortable: true,
                wrap: true,
            },
        ],
        []
    );

    useEffect(() => {
        dispatch(getFileUploadLogs());
    }, [dispatch]);

    // Access logs and loading state from Redux store
    const { fileUploadLogs, loading, error } = useSelector((state) => {
        return state.LogsReducer || {}
    });

    // console.log("fileUploadLogs >> ", fileUploadLogs);
    // console.log("loading >> ", loading);
    // console.log("error >> ", error);

    return (
        <div>
            <div className="page-heading-section">
                <div class="left-btn">
                    <p className="event-page-heading">Files Upload Logs</p>
                </div>
            </div>
            <ToastContainer />

            <div className="page-body">
                <Card className="my-2" style={{ padding: 0 }}>
                    <CardBody className="hotel-locations-card-body">
                        <DataTable
                            columns={columns}
                            theme=""
                            data={fileUploadLogs}
                            highlightOnHover
                            fixedHeader
                            progressPending={loading}
                            defaultSortAsc
                            pagination
                            sortIcon={<FilterListIcon />}
                        />
                    </CardBody>
                </Card>
            </div>
        </div>
    );
};
